import { parseJSON, format } from "date-fns";
// import i18n from "i18next";
// import { RootState } from "../redux/store/store";
// import { selectSettings } from "../redux/components/settings/settingsSlice";
// import { store } from "../redux/store/store";

class DateTimeFormatter {
  static formatTimestampAsTime(jsonTimestamp: string): string {
    if (jsonTimestamp === undefined || jsonTimestamp === null) {
      return "";
    }
    let timeFormat = "H:mm";
    // const settings = selectSettings(store.getState() as RootState);
    // let { timeFormat } = settings;
    if (timeFormat === undefined || timeFormat === null) {
      timeFormat = "H:mm";
    }
    const dT = parseJSON(jsonTimestamp);

    return format(dT, timeFormat);
  }
  static formatTimestampAsDate(jsonTimestamp: string): string {
    if (jsonTimestamp === undefined || jsonTimestamp === null) {
      return "";
    }
    let dateFormat = "yyyy-MM-dd";
    // const settings = selectSettings(store.getState() as RootState);
    // let { dateFormat } = settings;
    if (dateFormat === undefined || dateFormat === null) {
      dateFormat = "yyyy-MM-dd";
    }
    const dT = parseJSON(jsonTimestamp);

    return format(dT, dateFormat);
  }
}

export default DateTimeFormatter;
